export default __webpack_public_path__ + "static/media/clientImg6.2950af12.png";